import type {
  DatePickerInstance,
  ModelValue,
} from '@vuepic/vue-datepicker'
import type { PropType } from 'vue'
import type { DateType, UIOptions } from '@/types/datePicker'
import VueDatePicker from '@vuepic/vue-datepicker'
import dayjs from 'dayjs'
import { defineComponent, onMounted, ref, watch } from 'vue'
import '@vuepic/vue-datepicker/dist/main.css'

export default defineComponent({
  name: 'CalendarInput',
  components: { VueDatePicker },
  props: {
    errorText: { type: Array, required: false },
    objectKey: { type: String, required: true },
    value: {
      type:
        String
        || Number
        || (Array as PropType<ModelValue>)
        || (Object as PropType<ModelValue>),
      required: false,
    },
  },
  emits: ['dataChanged'],
  setup(props, { emit }) {
    const date = ref<ModelValue>(null)
    const datepicker = ref<DatePickerInstance>(null)

    const uiOptions: Partial<UIOptions> = {
      navBtnNext: 'custom-next-button',
      navBtnPrev: ['custom-prev-button', 'extra-class'],
      calendar: 'custom-calendar',
      calendarCell: 'custom-calendar-cell',
      menu: 'custom-datepicker-menu',
      input: 'custom-input-field',
    }

    const format = (date: Date) => {
      const day = date.getDate()
      const month = date.getMonth() + 1
      const year = date.getFullYear()
      return `${day}.${month}.${year}`
    }

    const formatDate = (dateString: DateType) => {
      const date = dayjs(dateString)
      return date.format('YYYY-MM-DD')
    }
    watch(date, async (newDate) => {
      emit('dataChanged', props.objectKey, formatDate(newDate as string))
    })

    onMounted(() => {
      if (props.value) {
        date.value = props.value
      }
    })

    return {
      date,
      datepicker,
      uiOptions,
      format,
      formatDate,
    }
  },
})
